// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"315e915e","453":"817673cc","455":"7f77ce06","977":"d224eda3"}[chunkId] + ".chunk.js";
};